import AceEditor, { IAceEditorProps } from 'react-ace';

import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/snippets/json';
import 'ace-builds/src-noconflict/ext-language_tools';
import 'ace-builds/src-noconflict/theme-xcode';

interface IEditorProps extends IAceEditorProps {
  id: string;
  code: string;
  setCode?: (code: string) => void;
}
export const Editor = ({ id, code, setCode, height = '175px', width, placeholder, ...props }: IEditorProps) => {
  const onChange = (newValue: string) => {
    if (setCode) {
      setCode(newValue || '');
    }
  };

  return (
    <AceEditor
      placeholder={placeholder}
      mode="json"
      theme="xcode"
      name={id}
      onChange={onChange}
      value={code}
      fontSize={12}
      minLines={3}
      width={width}
      height={height}
      setOptions={{
        useWorker: true,
        enableBasicAutocompletion: true,
        enableLiveAutocompletion: true,
        enableSnippets: true,
        showLineNumbers: true,
        wrapEnabled: true,
        tabSize: 2,
      }}
      {...props}
    />
  );
};
